"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconPlayCircle', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M10,17 C6.140375,17 3,13.859625 3,10 C3,6.140375 6.140375,3 10,3 C13.859625,3 17,6.140375 17,10 C17,13.859625 13.859625,17 10,17 M10,1 C14.9626,1 19,5.0374 19,10 C19,14.9626 14.9626,19 10,19 C5.0374,19 1,14.9626 1,10 C1,5.0374 5.0374,1 10,1 Z M13.0811,9.1865 L9.5811,6.6865 C9.2761,6.4675 8.8751,6.4405 8.5421,6.6105 C8.2091,6.7825 8.0001,7.1245 8.0001,7.4995 L8.0001,12.4995 C8.0001,12.8745 8.2091,13.2175 8.5421,13.3895 C8.6861,13.4635 8.8441,13.4995 9.0001,13.4995 C9.2051,13.4995 9.4081,13.4375 9.5811,13.3135 L13.0811,10.8135 C13.3441,10.6255 13.5001,10.3235 13.5001,9.9995 C13.5001,9.6765 13.3441,9.3735 13.0811,9.1865 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;